import { Component, OnInit } from '@angular/core';
import { ProfileService} from '../services/profile.service';
import {Message} from 'primeng/primeng';
import {ConfirmationService} from 'primeng/primeng';
import {SelectItem} from 'primeng/primeng';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  providers: [ConfirmationService]
})
export class ProfileComponent implements OnInit {

  msgs: Message[] = [];
  profile: any;
  profiles : any [];
  displayAdd: boolean = false;
  displayEdit: boolean = false;
  status: SelectItem[];
  blockedDocument: boolean = false;

  constructor(private profileService : ProfileService,private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.init();
    this.status = [
            {label: 'Habilitado', value: 'H', icon: 'fa fa-check-square-o'},
            {label: 'Inhabilitado', value: 'I', icon: 'fa fa-square-o'}
        ];
  }

  init(){
    this.profiles = [];
    this.profileService.findAll().then(data => {
      let response: any = data;
      response.profiles.forEach(item => {
        this.profiles.push(item);
      });
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });
    this.profile = {status:"H",storageTime:180};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  showAdd(){
    this.displayAdd = true;
  }

  showEdit(profile:any){
    this.profile=profile;
    this.displayEdit = true;
  }

  hide(){
    this.profile = {status:"H",storageTime:180};
    this.displayAdd = false;
    this.displayEdit = false;
    this.init();
  }

  add(){
    this.blockedDocument = true;
    this.profileService.create(this.profile).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  edit(){
    this.blockedDocument = true;
    this.profileService.edit(this.profile).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  del(id: number){
    this.confirmationService.confirm({
            message: 'Esta seguro de eliminar el registro seleccionado?',
            header: 'Confirmación',
            icon: 'fa fa-trash',
            accept: () => {
                this.blockedDocument = true;
                this.profileService.remove(id).then(data =>{
                  let response: any = data;
                    if(response.status == 'OK'){
                      this.init();
                      this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
                    }else{
                      this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
                    }
                    this.blockedDocument = false;
                }).catch(err =>{
                    this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
                    this.blockedDocument = false;
                });
            }
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts